// extracted by mini-css-extract-plugin
export default {"wrapper":"RecommendedItem_wrapper__tVL6Z","iconWrapper":"RecommendedItem_iconWrapper__F9oPN","icon":"RecommendedItem_icon__09EdD","category":"RecommendedItem_category__OIzs7"};